export function isDisabled(device) {
  return device.enabled === false;
}

export function isReadOnly(device) {
  if (device.device_class === DeviceClass.BATTERY) {
    return (
      device.enabled &&
      device.battery_tracking_enabled === false &&
      device.curtailment_enabled !== null &&
      device.curtailment === false
    );
  } else if (device.device_class === DeviceClass.SOLAR_INVERTER) {
    return device.curtailment_enabled === false;
  }
  return false;
}

export const DeviceClass = Object.freeze({
  METER: "meter",
  BATTERY: "battery",
  SOLAR_INVERTER: "solar_inverter",
});

export function get_config_edits_for_battery_op_mode(device_id, mode) {
  if (mode === BatteryOperationMode.DISABLED) {
  }
}

export const BatteryOperationMode = Object.freeze({
  READ_ONLY: 2,
  CONTROL: 3,
  ENABLED_WITH_CURTAILMENT: 4,
  DISABLED: 100,
});

export const BatteryGridMeter = Object.freeze({
  EXTERNAL: 1,
  INVERTER: 0,
});

export const PhaseConfiguration = Object.freeze({
  UNKNOWN: 0,
  L1L2L3: 1,
  L2L3L1: 2,
  L3L1L2: 3,
});

export const BatteryType = Object.freeze({
  HUAWEI: "Huawei",
  VICTRON: "Victron",
  SOLAREDGE: "SolarEdge",
  ZEROCO2: "ZeroCO2",
  HITE: "Hite",
  HITE_SC: "Hite-SC",
  HITE_CC: "Hite-CC",
  DEIFASC4: "DEIF-ASC4",
  SMARTLOGGER: "SmartLogger",
  SOLIS: "Solis",
  SIGENERGY: "Sigenergy",
  OCTAVE: "Octave",
  OCTAVE_ONE: "Octave-One",
  CBATTERY: "C-Battery",
  FRAX: "Frax",
  ENJOYPOWER: "EnjoyPower",
  GOODWE: "Goodwe",
  DYNESS: "Dyness",
  SOLAX: "Solax",
  ECUBE: "E-Cube",
  EBOX: "E-Box",
  JINKO: "Jinko",
  POWEROAD: "Poweroad",
  ELION_V3: "Elion-V3",
  EPES233: "Epes233",
  SUNGROW: "Sungrow",
  HOY: "Hoy",
  RISEN: "Risen",
  VIRTUAL: "Virtual",
  HOY_ULTRA2: "Hoy-Ultra-2",
  CBATTERY: "C-Battery",
  YUNT: "Yunt",
});

export const SolarInverterType = Object.freeze({
  HUAWEI: "Huawei",
  SMA: "SMA",
  SMA_SUNNYBOY: "SMA-Sunnyboy",
  SOLAREDGE: "SolarEdge",
  SUNGROW: "Sungrow",
  SOLARLOG: "SolarLog",
  GROWATT: "Growatt",
  ELION_V3: "Elion-V3",
  VIRTUAL: "Virtual",
  GOODWE_HT: "Goodwe-HT",
  GOODWE_MT: "Goodwe-MT",
  SUNGROW_DONGLE: "Sungrow-Dongle",
  BLUELOG: "Bluelog",
  GME: "GME",
});

export const TypeAlias = Object.freeze({
  SMA: "SMA Data Manager M",
  "SMA-Sunnyboy": "SMA Sunnyboy/Tripower",
  "Sungrow-Dongle": "Sungrow WiNet-S",
  Sungrow: "Sungrow Logger",
});

export function getTypeAlias(type) {
  return type in TypeAlias ? TypeAlias[type] : type;
}

export const MeterType = Object.freeze({
  GAVAZZI: "Gavazzi",
  GAVAZZI_EM24_E1: "Gavazzi-EM24-E1",
  SCHNEIDER_IEM3: "Schneider-iEM3",
  SCHNEIDER_PM5: "Schneider-PM5",
  SCHNEIDER_PM8: "Schneider-PM8",
  EASTRON: "Eastron",
  WAGO: "Wago",
  SMARTLOGGER: "SmartLogger",
  CHINT_DDSU666: "Chint-DDSU666",
  VIRTUAL: "Virtual",
  PHOENIX_CONTACT: "Phoenix-Contact",
  P1_DONGLE: "P1-Dongle",
  SIEMENS_7KM: "Siemens-7KM",
  DORNSCHEIDT_PRO380: "Dornscheidt-PRO380",
  PLA33RX: "PLA33RX",
  ELGRIS: "Elgris",
  SOCOMEC: "Socomec",
  UPM309: "UPM309",
  ELION_V3: "Elion-V3",
  LOVATO_DMG_EXS: "Lovato-DMG-EXS",
  CIOC_METER: "CIOC",
  A1_DONGLE: "A1-Dongle",
});

export const DeviceType = Object.freeze({
  ...BatteryType,
  ...MeterType,
  ...SolarInverterType,
});

export const BatteryTracking = Object.freeze({
  GRID: 0,
  HYBRID: 1,
  INTERNAL: 2,
  DISABLED: 100,
});

export const Protocol = Object.freeze({
  TCP: "TCP",
  TCP_RTU: "TCP-RTU",
  RS485: "RS485",
});

export const MeteringDirection = Object.freeze({
  NORMAL: 1,
  INVERTED: -1,
});

export const MeteringMode = Object.freeze({
  GRID: 0,
  INTERNAL: 1,
  LOGGING: 2,
});

export const MPPTTracking = Object.freeze({
  GRID: 0,
  INTERNAL: 1,
  DISABLED: 100,
});

export const SerialPath = Object.freeze({
  USB0: "/dev/serial/by-path/platform-xhci-hcd.5.auto-usb-0:1:1.0-port0",
  USB1: "/dev/serial/by-path/platform-xhci-hcd.4.auto-usb-0:1:1.0-port0",
  USB2: "/dev/serial/by-path/platform-fd840000.usb-usb-0:1:1.0-port0",
  USB3: "/dev/serial/by-path/platform-fd8c0000.usb-usb-0:1:1.0-port0",
});

export const DisabledTracking = Object.freeze({
  Huawei: [BatteryTracking.GRID],
  Victron: [BatteryTracking.HYBRID],
  Virtual: [],
  SolarEdge: [BatteryTracking.GRID],
  ZeroCO2: [],
  "DEIF-ASC4": [BatteryTracking.HYBRID, BatteryTracking.GRID],
  Hite: [BatteryTracking.GRID, BatteryTracking.HYBRID],
  Sigenergy: [BatteryTracking.GRID],
});
